import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Identity: React.FC<IconProps> = ({
  color = '#fff',
  size = 50,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 7C1 5.34315 2.34315 4 4 4H20C21.6569 4 23 5.34315 23 7V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V7ZM8 13.5C6.23625 13.5 4.77721 14.8046 4.53523 16.5015C4.49625 16.7749 4.72386 17 5 17H11C11.2761 17 11.5038 16.7749 11.4648 16.5015C11.2228 14.8046 9.76375 13.5 8 13.5ZM8 7.5C9.38071 7.5 10.5 8.61929 10.5 10C10.5 11.3807 9.38071 12.5 8 12.5C6.61929 12.5 5.5 11.3807 5.5 10C5.5 8.61929 6.61929 7.5 8 7.5ZM13 8.7V9.3C13 9.6866 13.3134 10 13.7 10H18.3C18.6866 10 19 9.6866 19 9.3V8.7C19 8.3134 18.6866 8 18.3 8H13.7C13.3134 8 13 8.3134 13 8.7ZM13.7 12H17.3C17.6866 12 18 12.3134 18 12.7V13.3C18 13.6866 17.6866 14 17.3 14H13.7C13.3134 14 13 13.6866 13 13.3V12.7C13 12.3134 13.3134 12 13.7 12Z"
      fill={color}
    />
  </svg>
)
